import { MobileFiltersDrawer } from "features/filters/components";

import { CAMPAIGNS_FILTERS } from "../../../constants";
import CampaignFilterOptions from "../CampaignFilterOptions";

import type { CampaignsSearchParams } from "../../../types";

interface MobileFiltersProps {
  searchParams: CampaignsSearchParams;
  setSearchParams: (searchParams: CampaignsSearchParams) => void;
  clearSearchParams: (() => void) | undefined;
}

export default function MobileFilters({
  searchParams,
  setSearchParams,
  clearSearchParams,
}: MobileFiltersProps) {
  return (
    <MobileFiltersDrawer
      title="Filter campaigns"
      onClear={(type) => {
        if (type === "all") {
          clearSearchParams();
        } else {
          setSearchParams({ ...searchParams, [type]: [] });
        }
      }}
      filters={CAMPAIGNS_FILTERS}
      getSelectionCount={(filterKey) => searchParams[filterKey].length}
      renderFilter={(filterKey) => (
        <CampaignFilterOptions
          searchParamsKey={filterKey}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
    />
  );
}
